<template>
  <div id="centros">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12 >
          <h4 class="grey--text text--darken-1">
            <v-icon small color="primary">drag_indicator</v-icon> Gestión de Inscripción de Participantes
          </h4>
        </v-flex>
      </v-layout>
      <v-card>
        <v-card-title class="headline lighten-3">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Buscar"
            single-line
          >
          </v-text-field>

          <v-flex xs12 class="my-0 py-0">
            <v-card-title class="grey lighten-4 py-1 px-1">
              <h6 class="grey--text text--darken-1">Solo puede inscribir participantes hasta 48 horas después de la fecha de inicio del curso.</h6>
            </v-card-title>
            <v-divider class="mb-0"></v-divider>
          </v-flex>
        </v-card-title>
        <v-data-table
            :headers="headers"
            :loading="loading"
            :items="curof"
            class="elevation-1"
            rows-per-page-text="Filas por página"
            no-data-text="No existen registros"
            no-results-text="Sin resultados"
            page-text="de"
            :rows-per-page-items="[10, 25, 50, 100, {'text': 'Todos', value: -1}]"
            v-bind:search="search"
            v-cloak
          >
            <template v-slot:items="props">
              <td>{{ props.index + 1 }}</td>
              <td>{{ props.item.nombre }}</td>
              <td>{{ props.item.gestion_tipo_id }}</td>
              <td>{{ props.item.fecha_inicio | formatdate }}</td>
              <td>{{ props.item.fecha_fin | formatdate }}</td>
              <td>{{ props.item.hora_inicio }}</td>
              <td>{{ props.item.hora_fin }}</td>
              <td><strong>{{ props.item.limi | formatdate }}</strong></td>
              <td><span v-if="props.item.es_vigente == true"><v-chip small color="success lighten-2">abierto</v-chip></span>
                <span v-else><v-chip small color="red lighten-2">cerrado</v-chip></span>
              </td>
              <td>
                <v-tooltip bottom v-if="props.item.hoy <= props.item.limi">
                  <template v-slot:activator="{on}">
                    <v-btn
                      v-on="on"
                      dark
                      icon
                      small
                      depressed
                      color="primary"
                      @click="showDetail(props.item.codigomain)"
                      
                    >
                      <v-icon small>content_paste</v-icon>
                    </v-btn>
                  </template>
                  <span>Inscribir participante</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{on}">
                    <v-btn
                      v-on="on"
                      dark
                      icon
                      small
                      depressed
                      color="success"
                      @click="showInscritos(props.item.codigomain)"
                    >
                      <v-icon small>visibility</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver participantes inscritos</span>
                </v-tooltip>
              </td>
              
            </template>
          </v-data-table>
      </v-card>
    </v-container>
    <v-dialog
        v-model="dialogDetail"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
      >
        <detalle-inscripcion :mcodigo="codigocur" :mcursod="cursoD" :mband="band" :mloading="loadingDetail" @close="dialogDetail = false"></detalle-inscripcion>
    </v-dialog>
    <v-dialog
        v-model="dialogDetail2"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
        scrollable
      >
        <detalle-inscritos :mcodigo2="codigocur2" :minscur="inscur" :mband="band" :mloading="loadingDetail2" @close="dialogDetail2 = false"></detalle-inscritos>
    </v-dialog>
    
    <v-snackbar
      v-model="snack.state"
      top
      right
      :timeout="2500"
      :color="snack.color"
      :multi-line="snack.mode === 'multi-line'"
    >
      {{ snack.text }}
    </v-snackbar>
  </div>
</template>
<script>
/* eslint-disable no-console */
import Service from "../services/general";
import axios from "axios";
import DetalleInscripcion from '@/components/DetalleInscripcion';
import DetalleInscritos from '@/components/DetalleInscritos';
export default {
  name: "cursosof",
  components: {
    DetalleInscripcion,
    DetalleInscritos
  },
  data() {
    return {
      dialogDetail: false,
      loadingDetail: false,
      dialogDetail2: false,
      loadingDetail2: false,
      search: "",
      snack: {
          state: false,
          color: 'success',
          mode: '',
          text: ''
        },
      headers: [
        { text: 'Nro', align: 'left', sortable: false },
        { text: 'Curso ', value: 'nombre' },
        { text: 'Gestión ', value: 'gestion_tipo_id' },
        { text: "Fecha Inicio ", value: "fecha_inicio" },
        { text: 'Fecha Fin ', value: 'fecha_fin' },
        { text: 'Hora Inicio ', value: 'hora_inicio' },
        { text: 'Hora fin ', value: 'hora_fin' },
        { text: 'Lim. Inscrip. ', value: 'limi' },
        { text: 'Estado ', value: 'es_vigente' },
        { text: 'Acción', sortable: false, width: '145px' }
       ],
      loading: false,
      curof: [],
      curso: [],
      codigo_centro: '',
      mconfirm: false,
      idborrar: '',
      codigocur: '',
      codigocur2: '',
      inscur: [],
      cursoD: [],
      band: [],
      fechalimite: '',
      fechaaux: '',
      auxiliar: '',
      hoy: '',
      hoycorto: ''      
    };
  },
  mounted() {
    this.dparams = Service.getParams(); 
      if (this.dparams && this.dparams.roluser != Service.rol().director) {
        this.$router.push({name: 'principal'});
      }
      if (this.dparams != null) {
        this.getCursosOfertadosA();
      }

     
  },
  methods: {
   
    getCursosOfertadosA() { 
      this.dparams = Service.getParams();
        this.loading = true;
        axios
          .get(Service.getBase() + 'lista/cursosabiertos/' + this.dparams.ie_id, Service.getHeader())
          .then(response => { 
            this.loading = false; 
            this.curof = response.data; //console.log(this.curof);

            for(let c=0;c<=this.curof.length;c++){ 
              this.fechaaux = new Date(this.curof[c].fecha_inicio + 'T00:00:00');
              this.auxiliar = this.sumarDias(this.fechaaux, 2); // suma 2 dias a la fecha de inicio de curso para control de periodo de inscripciones
              
              this.auxiliar = this.auxiliar.toLocaleDateString(); //formateando YYYY-mm-dd
              this.auxiliar = this.auxiliar.split('/'); 
              for(let c=this.auxiliar.length-1;c>=0;c--){
                if(this.auxiliar[c] < 10){
                  this.auxiliar[c] = '0' + this.auxiliar[c];
                }
                this.fechalimite = this.fechalimite + this.auxiliar[c] + '-';
              }
              this.fechalimite = this.fechalimite.substring(0, this.fechalimite.length - 1);  //fechalimite es la fecha 48 horas despues del inicio del curso
              this.curof[c].limi = this.fechalimite;
              
              this.hoy = new Date();
              this.hoy = this.hoy.toLocaleDateString(); //formateando YYYY-mm-dd
              this.hoy = this.hoy.split('/'); 
              for(let c=this.hoy.length-1;c>=0;c--){
                if(this.hoy[c] < 10){
                  this.hoy[c] = '0' + this.hoy[c];
                }
                this.hoycorto = this.hoycorto + this.hoy[c] + '-';
              }
              this.hoycorto = this.hoycorto.substring(0, this.hoycorto.length - 1);  //se formatea hoy para ver si hoy esta dentro de las 48 horas de plazo para inscribir despues de la fecha de inicio del curso
              this.curof[c].hoy = this.hoycorto;

              this.fechalimite = '';
              this.hoycorto = '';
            }
          })
          .catch(error => {
            this.loading = false;
            console.error("Error al cargar registros", error);
          });
        
    },
    showDetail(codigo) { 
        this.dialogDetail = true;
        this.loadingDetail = true;
        this.codigocur = codigo; 

        this.becario(this.codigocur);

        axios
          .get(Service.getBase() + 'cursos/datos/' +  this.codigocur, Service.getHeader())
          .then(response => { 
            this.loading = false; 
            this.cursoD = response.data.cursoD[0]; //console.log(this.cursoD);
          })
          .catch(error => {
            this.loading = false;
            console.error("Error al cargar registros", error);
          });

      

      },  
      becario(codigo){
      
      axios
        .get(Service.getBase() + "lista/becas/" + codigo, Service.getHeader())
        .then(response => {
            this.band = response.data; //console.log(this.band.bandera);
            
        })
        .catch(error => {
          this.toast("error", "No se pudo cargar " + error);
        });
    },
    showInscritos(codigo) { 
        this.dialogDetail2 = true;
        this.loadingDetail2 = true;
        this.codigocur2 = codigo; 

        this.loading = true; 
        axios
          .get(Service.getBase() + 'lista/inscritoscurso/' +  this.codigocur2, Service.getHeader())
          .then(response => { 
            this.loading = false; 
            this.inscur = response.data; //console.log(this.inscur);
           if(response.data.length != 0){  //si no hay registros no muestra los datos del curso
              this.band = true; 
            }else{
              this.band = false;
            }

            for(let c=0;c<=this.inscur.length;c++){ 
              this.fechaaux = new Date(this.inscur[c].fecha_inicio + 'T00:00:00');
              this.auxiliar = this.sumarDias(this.fechaaux, 2); // suma 2 dias a la fecha de inicio de curso para control de periodo de inscripciones
              
              this.auxiliar = this.auxiliar.toLocaleDateString(); //formateando YYYY-mm-dd
              this.auxiliar = this.auxiliar.split('/'); 
              for(let c=this.auxiliar.length-1;c>=0;c--){
                if(this.auxiliar[c] < 10){
                  this.auxiliar[c] = '0' + this.auxiliar[c];
                }
                this.fechalimite = this.fechalimite + this.auxiliar[c] + '-';
              }
              this.fechalimite = this.fechalimite.substring(0, this.fechalimite.length - 1);  //fechalimite es la fecha 48 horas despues del inicio del curso
              this.inscur[c].limi = this.fechalimite;
              
              this.hoy = new Date();
              this.hoy = this.hoy.toLocaleDateString(); //formateando YYYY-mm-dd
              this.hoy = this.hoy.split('/'); 
              for(let c=this.hoy.length-1;c>=0;c--){
                if(this.hoy[c] < 10){
                  this.hoy[c] = '0' + this.hoy[c];
                }
                this.hoycorto = this.hoycorto + this.hoy[c] + '-';
              }
              this.hoycorto = this.hoycorto.substring(0, this.hoycorto.length - 1);  //se formatea hoy para ver si hoy esta dentro de las 48 horas de plazo para inscribir despues de la fecha de inicio del curso
              this.inscur[c].hoy = this.hoycorto;

              this.fechalimite = '';
              this.hoycorto = '';
            }

          })
          .catch(error => {
            this.loading = false;
            console.error("Error al cargar registros", error);
          });
      },
   
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    },

    sumarDias(fecha, dias){
      fecha.setDate(fecha.getDate() + dias);
      return fecha;
    }
  }
};
</script>